const initialState = {
  data: {},
  categories: []
};

function DocumentsReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_DOCUMENT_CATEGORY':
      return {
        ...state,
        data: action.value.data
      };
    case 'SET_ALL_CATEGORIES':
      return {
        ...state,
        categories: action.value
      };
    default:
      return state;
  }
}
export default DocumentsReducer;
